// extracted by mini-css-extract-plugin
export default {"red":"ButtonThumb_red__KbTKr","green":"ButtonThumb_green__MMwah","buttonThumb":"ButtonThumb_buttonThumb__dsRti"};